module.exports = __webpack_public_path__ + "img/main1.a1f5239e.png";